/**
 * Canonical identifiers for the patient-facing legal documents.
 *
 * These are the SOURCE OF TRUTH for "which version did the member agree to".
 * They must be updated by hand whenever the corresponding page text changes,
 * and never derived from `new Date()` — an earlier revision rendered
 * `new Date().toLocaleDateString()` as the "last updated" line, so both pages
 * claimed to have been revised on whatever day they happened to be viewed.
 *
 * The privacy notice text on /privacy (src/legal/privacy.ts) is ported verbatim
 * from the controlled document "Melio Privacy Notice — Patient Facing" (Melio
 * Health Solutions Ltd, data room). Keep PRIVACY_NOTICE_VERSION in step with that document's version
 * table; if the two ever disagree, the data-room document wins and the page is
 * wrong.
 */

export const PRIVACY_NOTICE_VERSION = '1.4';
export const PRIVACY_NOTICE_DATE = '11 September 2026';

/**
 * /terms is ported verbatim from the controlled document "Melio Membership
 * Terms of Service — Patient Facing" (Melio Health Solutions Ltd, data room).
 * Same rule as the privacy notice: if page and data-room document disagree, the
 * document wins and the page is wrong.
 */
export const TERMS_VERSION = '1.3';
export const TERMS_DATE = '11 September 2026';

/**
 * The website waitlist collection notice (W-8).
 *
 * DELIBERATELY SEPARATE FROM PRIVACY_NOTICE_VERSION. The /privacy sections are
 * a verbatim port of a controlled data-room document, and the rule above is
 * that the document wins if the two disagree. Adding a waitlist section to
 * those sections and calling the result "v1.3" would have invented a revision
 * of a controlled legal document that nobody approved - the page would then be
 * wrong by its own definition.
 *
 * So the waitlist information is published as a clearly-labelled addendum with
 * its own version line. It carries the UK GDPR Article 13 information for
 * people who join the list before the controlled document's next revision
 * folds it in; at that point this constant retires and the section becomes part
 * of the main notice.
 *
 * Separate again from WAITLIST_CONSENT_VERSION (types/waitlist), which versions
 * the consent SENTENCE shown beside the tickbox. That sentence is unchanged, so
 * it is not bumped here.
 *
 * Addendum history (the LegalAddendum type carries no history array):
 *   1.3  17 September 2026  focus-areas question replaces "which assessment" (b2d1448)
 *   1.4  9 October 2026     deposit reduced to £50 (#23); wording otherwise unchanged
 */
export const WAITLIST_NOTICE_VERSION = '1.4';
export const WAITLIST_NOTICE_DATE = '9 October 2026';
